import { render, staticRenderFns } from "./GiftCardAddToPayment.vue?vue&type=template&id=0bd87596&scoped=true"
import script from "./GiftCardAddToPayment.vue?vue&type=script&lang=js"
export * from "./GiftCardAddToPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd87596",
  null
  
)

export default component.exports